
/* poussiere de fee de la section newsletter */
(function(){
  var dusts=document.querySelectorAll('.nl-dust,.f-dust');
  for(var k=0;k<dusts.length;k++){
    var f2=document.createDocumentFragment();
    for(var j=0;j<10;j++){
      var d=document.createElement('span');
      var ds=(Math.random()*3+2.6).toFixed(1);
      d.style.width=ds+'px'; d.style.height=ds+'px';
      d.style.left=(Math.random()*96+2).toFixed(2)+'%';
      d.style.setProperty('--d',(Math.random()*7+13).toFixed(1)+'s');
      d.style.setProperty('--delay',(-Math.random()*20).toFixed(1)+'s');
      d.style.setProperty('--dx',((Math.random()*80-40)|0)+'px');
      d.style.setProperty('--o',(Math.random()*.35+.3).toFixed(2));
      f2.appendChild(d);
    }
    dusts[k].appendChild(f2);
  }
})();
